module.exports = __webpack_public_path__ + "img/SSD.4f82a2fe.gif";